import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { etapesDuLot, morceauxLances } from '../../../../lib/reglesEdition.js';
import type { LotReprise } from '../../../../lib/reprise.js';
import styles from './Correspondance.module.css';

/**
 * Les étapes d'un lot tiré d'un dépôt, dans l'ordre où elles se suivent :
 * déposé, profilé, correspondance, transformé, essai par morceaux, morceaux à
 * lancer. La première étape non faite est la courante ; c'est là que se
 * trouve le prochain geste.
 */
export function EtapesLot({ lot }: { lot: LotReprise }): JSX.Element {
  const { t } = useTranslation('console');
  const morceaux = lot.morceaux?.liste ?? [];
  const detail = (etape: string): string | null => {
    if (morceaux.length === 0) return null;
    if (etape === 'essai')
      return t('correspondance.etapes.detailEssai', {
        faits: morceaux.filter((morceau) => morceau.etat !== 'depose').length,
        total: morceaux.length,
      });
    if (etape === 'a_lancer')
      return t('correspondance.etapes.detailLancement', {
        faits: morceauxLances(lot),
        total: morceaux.length,
      });
    return null;
  };

  return (
    <ol className={styles.etapes} aria-label={t('correspondance.etapes.aria')}>
      {etapesDuLot(lot).map(({ etape, etat }) => {
        const complement = detail(etape);
        return (
          <li
            key={etape}
            className={styles.etape}
            data-etat={etat}
            aria-current={etat === 'courante' ? 'step' : undefined}
          >
            <span className={styles.etapeNom}>{t(`correspondance.etapes.${etape}`)}</span>
            <span className={styles.etapeEtat}>{t(`correspondance.etapes.etat.${etat}`)}</span>
            {complement ? <span className={styles.etapeDetail}>{complement}</span> : null}
          </li>
        );
      })}
    </ol>
  );
}
